import React, { useEffect, useState } from "react";
import styled from "styled-components";
import tw from "twin.macro";

const API_URL = process.env.REACT_APP_IS_PROD == "true" ? process.env.REACT_APP_API_URL_PROD : process.env.REACT_APP_API_URL_DEV


const Card = styled.div`
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 16px;
  width: 100%;
  margin: 10px auto;
  font-family: Arial, sans-serif;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

const Title = styled.h2`
    font-size: 32px;
    font-weight: bold;
    margin-bottom: 30px;
    mergin-left:30px;

    @media (max-width: 768px) {
       font-size: 18px;
       font-weight: bold;
    }
`;

const Image = styled.img`
  width: 200px;
  height: 100%;
  object-fit: cover;
  border-radius: 12px; /* Adjust for rounded corners */

  @media (max-width: 600px) {
    width: 100%;
    height: 200px;
    border-radius: 8px; /* Smaller rounding for small screens */
  }
`;


const Content = styled.div`
  flex: 1;
`;


const List = styled.ol`
  padding-left: 20px;
  margin: 0;
`;

const ListItem = styled.li`
  font-size: 16px;
  color: #555;
  margin-bottom: 8px;
`;

const Section = styled.div`
  ${tw`mt-10`};
  width: 95%;
  margin: auto;
`;

const SafetyCard = ({ destinationId, destinationName }) => {
  const [tips, setTips] = useState(null);

  useEffect(() => {
    const fetchTips = async () => {

      try {
        const response = await fetch(`${API_URL}/web/destinations/safety/?destid=${destinationId}`, {
          headers: {
            'X-API-Key': process.env.REACT_APP_ACCESS_API_KEY // Add API key to headers
          }
        });
        const result = await response.json();

        if (result.header.resCode === 200 && result.data.length > 0) {
          setTips(result.data);
        }
      } catch (error) {
        console.error('Error fetching destination data:', error);
      }
    };

    fetchTips();
  }, [destinationId]);

  return (
    <>
      <br /><br />
      {
        tips &&
        <Section>
          <Title>Safety Guidlines for {destinationName}</Title>
          <Card>
            <Image src="https://images.pexels.com/photos/30861116/pexels-photo-30861116/free-photo-of-snow-covered-forest-road-in-winter.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2" alt="Safety Sign" />
            <Content>
              <List>
                {tips.map((tip, index) => (
                  <ListItem key={index}>{index + 1}. {tip}</ListItem>
                ))}
              </List>
            </Content>
          </Card>
        </Section>
      }
    </>
  );
};

export default SafetyCard;
